import React from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import { Col, Row } from "react-bootstrap"
import { DckSelectors, DckActionCreators } from "dck-redux"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import { BooleanStatuses, bucketDataWithId, CardType, fillingZeroUtility,
  formatCurrency,
  selectFiltersFromStore,
  sortDate } from "../../../lib/utils"
import UIAvatar from "../../fragments/UIAvatar"
import BusinessLink from "../../fragments/BusinessLink"
import FinancierBatchCard from "./Card"
import { getBatchPaymentDetails, getLoansTotalRepayment } from "../financierHelper"

class ListFinancierBatches extends React.Component {

  _isMounted = false

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAdminOrAccountant = this.isAdmin || this.authenticated.isAccountant()

  state = {
    selectedRow: null,
    isSelected: false,
    allUpfrontPayment: 0,
    allTotalRepayment: 0,
    runningRepaymentSummary: false,
  }

  componentDidMount() {

    this._isMounted = true
    const { loadData, loadBuckets } = this.props
    loadData()
    loadBuckets()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  loadPaymentDetails = financierBatch => {

    const { upfrontTotal, fineractIds } = getBatchPaymentDetails(financierBatch)
    this.setState({
      allUpfrontPayment: upfrontTotal,
      allTotalRepayment: 0,
      runningRepaymentSummary: false,
    })

    if (fineractIds.length) {

      this.setState({ runningRepaymentSummary: true })
      getLoansTotalRepayment(fineractIds)
      .then(allTotalRepayment => {

        if (this._isMounted) {
          this.setState({ allTotalRepayment })
        }
      })
      .catch(error => console.error(error))
      .finally(() => {

        if (this._isMounted) {
          this.setState({ runningRepaymentSummary: false })
        }
      })
    }
  }

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.affiliationName.cleanFiltered()
    this.refs.nbLoans.cleanFiltered()
    this.refs.currencyCode.cleanFiltered()
    this.refs.purchaseCost.cleanFiltered()
    this.refs.sellingCost.cleanFiltered()
    this.refs.closed.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  itemSelected = (selectedRow, isSelected) => {

    this.setState({
      selectedRow,
      isSelected
    })

    const { batches } = this.props,
    financierBatch = isSelected && selectedRow
      ? this.getElementById(selectedRow.id, batches) : null

    if (financierBatch) {
      this.loadPaymentDetails(financierBatch)
    }
  }

  updateLink = id => `/financiers/batches/${id}/update`

  detailsLink = id => `/financiers/batches/${id}/detail`

  renderUpdateLink = id => {

    if(!this.isAdmin) return null
    return (
      <Link to={ this.updateLink(id) } className="p-5">
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  getElementById = (id, data) => data.find(item => item.id === id)

  renderTable = (batches, affiliationNameFilters) =>
    <SingleSelectTable
      items={ batches }
      addNewLabel="Add Batch"
      addNewHandler={() => browserHistory.push("/financiers/batches/create")}
      exportCSV={ this.isAdminOrAccountant }
      csvFileName='batches.csv'
      shouldRenderToolbar={ this.isAdminOrAccountant }
      itemSelected={ this.itemSelected }
    >
      <TableHeaderColumn
        dataField="id"
        isKey
        dataAlign="center"
        dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
        csvHeader="Batch ID"
        width='48'
      />

      <TableHeaderColumn
        ref='name'
        dataField="name"
        dataSort
        dataAlign="center"
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, { id, name, closed }) =>
          this.renderDetailLink(id, <span className={ closed ? 'red' : ''}>{ name }</span>)}
        csvHeader="Name"
        columnClassName="min-w-120"
      >
        Name
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='affiliationName'
        dataField="affiliationName"
        dataSort
        filter={{ type: "SelectFilter", options: affiliationNameFilters }}
        dataAlign="center"
        dataFormat={(_, { affiliation: { id, name, businessId }}) => !!id &&
          <BusinessLink id={ id } name={ name } businessId={ businessId } /> }
        csvHeader="Affiliation"
        columnClassName="min-w-120"
      >
        Affiliation
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='nbLoans'
        dataField="nbLoans"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataFormat={value => fillingZeroUtility(value)}
        dataAlign="center"
        csvHeader="Nb Loans"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        NB loans
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='currencyCode'
        dataField="currencyCode"
        dataSort
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={value => fillingZeroUtility(value)}
        dataAlign="center"
        csvHeader="Currency code"
        columnClassName="min-w-120"
      >
        Currency code
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='purchaseCost'
        dataField="purchaseCost"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="T. purchase cost"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        T. purchase cost
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='sellingCost'
        dataField="sellingCost"
        dataSort
        filter={{ type: "NumberFilter", delay: 1000 }}
        dataAlign="center"
        dataFormat={cell => formatCurrency(cell)}
        csvHeader="T. selling price"
        csvFieldType="number"
        columnClassName="min-w-120"
      >
        T. selling price
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='closed'
        dataField="closed"
        dataAlign="center"
        dataSort
        tdStyle={{ verticalAlign: 'middle' }}
        dataFormat={ value => value ? <FontAwesome style={{ color: 'green' }} name='check' /> : ''}
        filter={{ type: "SelectFilter", options: BooleanStatuses }}
        csvHeader="Closed"
        width="90"
      >
        Closed
      </TableHeaderColumn>

      <TableHeaderColumn
        ref='createdOnFormatted'
        dataField="createdOnFormatted"
        dataAlign="center"
        dataSort
        sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
        filter={{ type: "DateFilter", delay: 1000 }}
        csvHeader="Created On"
        columnClassName='text-xs'
        width="140"
      >
        Created On
      </TableHeaderColumn>

      <TableHeaderColumn
        dataAlign="center"
        width="80px"
        dataFormat={(_, row) =>
        <span className="flex-detail">
          { this.renderDetailLink(row.id, <FontAwesome name="eye" title='View' />) }
          { this.renderUpdateLink(row.id) }
        </span>}
      />
    </SingleSelectTable>

  render() {
    const { batches, buckets, setFinancierBatch, reloadFinancierBatch, removeFinancierBatch,
      affiliationNameFilters } = this.props,

    { selectedRow, isSelected, allUpfrontPayment, allTotalRepayment,
      runningRepaymentSummary } = this.state,

    financierBatch = selectedRow ? this.getElementById(selectedRow.id, batches) : null,

    meetCond = isSelected && !!financierBatch

    return (
      <div>
        <CustomBreadCrumb activeText='Batches' data={ [{ url: '/financiers', title: 'Financiers' }] } />

        <Row>
          <Col md={ meetCond ? 8 : 12 }>
            <ClearFiltersButton onClick={ this.doClearFilters } />
            { this.renderTable(batches, affiliationNameFilters) }
          </Col>

          { meetCond &&
            <Col md={4}>
              <FinancierBatchCard 
                financierBatch={ financierBatch }
                setFinancierBatch={ setFinancierBatch }
                reloadFinancierBatch={ reloadFinancierBatch }
                removeFinancierBatch={ removeFinancierBatch }
                cardType={ CardType.SMALL }
                buckets={ buckets }
                allUpfrontPayment={ allUpfrontPayment }
                allTotalRepayment={ allTotalRepayment }
                runningRepaymentSummary={ runningRepaymentSummary }
              />
            </Col>
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {

  const batches = DckSelectors.selectAllItems(state, ItemTypes.FinancierBatch),

  affiliationNameFilters = selectFiltersFromStore(state, ItemTypes.FinancierAffiliationFilter)

  let bucks = DckSelectors.selectAllItems(state, ItemTypes.FinancierBucket)
  bucks = bucks.filter(({ closed }) => !closed)
  bucks.sort((a, b) => a.name.localeCompare(b.name))

  const buckets = bucketDataWithId(bucks)

  return { batches, buckets, affiliationNameFilters }
},

mapDispatchToProps = dispatch => ({

  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.FinancierBatch)),

  setFinancierBatch: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.FinancierBatch, id, data)),

  reloadFinancierBatch: id => dispatch(DckActionCreators.itemReload(ItemTypes.FinancierBatch, id)),

  removeFinancierBatch: id => dispatch(DckActionCreators.itemRemove(ItemTypes.FinancierBatch, id)),

  loadBuckets: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.FinancierBucket)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListFinancierBatches)



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/List.js